import React from "react";

export default function InputLabel({
  label,
  labelClassName,
  margin,
  id,
  type = "text",
  autoComplete = "off",
  className = "form-control",
  ...rest
}) {
  return (
    <div className="form-label-group">
      <input
        autoComplete={autoComplete}
        type={type}
        id={id}
        className={className}
        placeholder={label}
        {...rest}
      />
      <label className={labelClassName} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}
